import { AutoComplete } from "@src/components";
import { useGetAutocompleteQuery } from "@src/query/editor/EditorQuery";
import { createAutocompleteDisplayValue } from "@src/utils/utils";
import { useEffect, useState } from "react";

export const StopCodon = ({ onCodonChange, ...rest }: any) => {
  const [term, setTerm] = useState<string | undefined>();
  const [debouncedTerm, setDebouncedTerm] = useState<string | undefined>();
  const [disabled, setDisabled] = useState<boolean>(!rest.genome);
  const { data, isFetching } = useGetAutocompleteQuery(
    rest.genome,
    debouncedTerm
  );
  const [selected, setSelected] = useState<any | undefined>();

  const handleSelectSuggestion = (suggestion?: string) => {
    setSelected(suggestion);
    setTerm(createAutocompleteDisplayValue(suggestion));
  };

  useEffect(() => {
    if (selected) {
      onCodonChange(selected);
    }
    setDisabled(!rest.genome);
  }, [selected, rest.genome]);

  useEffect(() => {
    if (rest.clearButtonClick) {
      setSelected("");
      setTerm("");
    }
  }, [rest.clearButtonClick]);

  return (
    <AutoComplete
      placeholder="Enter Gene Symbol, Gene ID or Alias"
      suggestions={data?.data}
      value={term}
      onChange={setTerm}
      onChangeDebounced={setDebouncedTerm}
      onSelectSuggestion={handleSelectSuggestion}
      selectedSuggestion={selected?.gene_id}
      disabled={disabled}
      min={3}
      isLoading={isFetching}
    />
  );
};
